import 'angular:locale/data:it';
import 'angular:locale/data:cat';
import 'angular:locale/data:en';
import 'angular:locale/data:es-ES';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
